<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">消息类型：</span>
        </div>
        <el-input v-model="name" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否启用：</span>
        </div>
        <el-switch
          v-model="statusOnPage"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>

      <div class="form-line" v-if="name === '合同到期提醒'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">距离合同到期天数：</span>
        </div>
        <el-input v-model="remainingDays" size="small" style="width: 280px">
          <template slot="append">天</template>
        </el-input>
      </div>

      <div class="form-line" v-if="name === '账单到期提醒'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">距离账单到期天数：</span>
        </div>
        <el-input v-model="remainingDays" size="small" style="width: 280px">
          <template slot="append">天</template>
        </el-input>
      </div>

      <div class="form-line" v-if="name === '用电余额不足提醒'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">余额不足：</span>
        </div>
        <el-input v-model="balance" size="small" style="width: 280px" v-on:blur="changeBalance()">
          <template slot="append">元</template>
        </el-input>
      </div>


      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../../utils/errorHandler'
  import InputTree from '../../../../components/common/inputs/input-tree'
  import {pattern} from '../../../../utils/regular'
  import {api} from '../../../api/ConfigManagement'
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../../utils/notice'
  import ButtonConfirmNext from '../../../../components/Button/ButtonConfirmNext'
  import InputDatePicker from '../../../../components/Input/InputDatePicker'
  import {bus} from '../../../../utils/bus'

  export default {
    components: {
      InputDatePicker,
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'config-modify',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧消息',
            name: 'message-template-manage'
          }, {
            value: '消息推送配置'
          }],
        },
        mainTitle: '修改配置',
        statusOnPage: false,
        code: '',
        name: '',
        status: '',
        remainingDays: '',
        balance: ''
      }
    },
    created () {
      this.code = this.$route.params.id
      this.getByCode()
    },
    methods: {
      getByCode () {
        this.$axios.get(`${api.getByCode}/${this.code}`, {})
          .then(res => {
            let data = res.data.data
            this.name = data.name
            this.status = data.status
            this.remainingDays = data.remainingDays
            this.balance = data.balance
            if (data.status === '1') {
              this.statusOnPage = false
            } else {
              this.statusOnPage = true
            }
          })
          .catch(errorHandler('获取授权数据失败'))
      },

      remoteMethod (query) {
        this.getRentList(query)
      },

      changeBalance () {
        if (this.balance) {
          this.balance = (parseFloat(this.balance).toFixed(2)).toString()
        } else {
          this.balance = '0.00'
        }
      },

      add () {
        if (this.name === '合同到期提醒' && !this.remainingDays) {
          nError('请输入距离合同到期天数')
          return false
        }
        let obj = {
          code: this.code,
          name: this.name,
          status: this.status,
          remainingDays: this.remainingDays,
          balance: parseFloat(this.balance) || 0.00
        }
        this.$axios.post(api.saveOrUpdate, obj)
          .then(res => {
            if (res.data.retCode == 1) {
              nSuccess('修改成功')
              this.strategyCenter()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'config-management'
        })
      }
    },
    watch: {
      statusOnPage (v) {
        if (this.statusOnPage) {
          this.status = '0'
        } else {
          this.status = '1'
        }
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 160px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/MessagePush/configModify.vue